export default __webpack_public_path__ + "img/akitabox_horizontal_white.svg";